<template>
    <PageContent>
        <PageTitle>Purchase History (Summerized)</PageTitle>
        <div class="container">
            <div class="row">
                <div class=" col-xl-6 offset-xl-3 border p-3">
                    <form @submit.prevent.stop="">
                        <fieldset :disabled="busy">
                            <div class="form-group">
                                <label for="">Order Date</label>
                                <div class="row mt-1">
                                    <div class="col-lg-6">
                                        <label>From</label>
                                        <input type="text" name="txtsdate" v-model="txtsdate" class="form-control datepicker" required>
                                    </div>
                                    <div class="col-lg-6">
                                        <label for="">To</label>
                                        <input type="text" name="txtedate" v-model="txtedate" class="form-control datepicker" required>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="">Level</label>
                                <select size="1" name="level" v-model="level" class="form-control">
                                    <option>Total</option>
                                    <option>Route</option>
                                    <option>Location</option>
                                    <option>Ship-To, Total</option>
                                    <option>Ship-To, Route</option>
                                    <option>Ship-To, Location</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="">Detail</label>
                                <select v-model="detail" class="form-control">
                                    <option value="Item">Item</option>
                                    <option value="Price Code">Price Code</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="">Code Display Source</label>
                                <select class="form-control" v-model="DisplayCode">
                                    <option value="LABEL CODE">LABEL CODE</option>
                                    <option value="MSRP      ">MSRP      </option>
                                    <option value="MSRP CODE ">MSRP CODE </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="">Include Waste</label>
                                <div class="form-check form-switch">
                                    <input class="form-check-input" name="WasteHist" type="checkbox" id="waste" true-value="YES" false-value="NO" v-model="WasteHist">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="">File Type</label>
                                <select class="form-control" v-model="filetype">
                                    <option value="PDF">PDF</option>
                                    <option value="CSV">CSV</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="filetype == 'CSV'">
                                <label for="">File Sort</label>
                                <select v-model="sort" class="form-control">
                                    <option value="ITEM #">Item #</option>
                                    <option value="QUANTITY ORDERED">Quantity Ordered</option>
                                    <option value="PRICE CODE">Price Code</option>
                                </select>
                            </div>
                            <div class="mt-3">
                                <!-- <a class="btn btn-secondary" :href="`${$store.state.api}/pdfs/OrderSummaryFile-${filetype}.php?&txtsdate=${txtsdate}&txtedate=${txtedate}&level=${level}&detail=${detail}&DisplayCode=${DisplayCode}&waste=${WasteHist}&filetype=${filetype}&sort=Item No&reportdata=Report Style&BTNSUBMIT=SUBMIT&Function=GETDATA&token=${$store.state.localStorage.token}&lccustno=${$root.getCustomerNumber()}`" target="_blank">Submit</a> -->
                                <a class="btn btn-secondary" v-if="!busy" @click.prevent.stop="getFile" :href="`http://www.kffoods.com/wconnect/purchasehist.kf?&custno=${$root.getCustomerNumber()}&filetype=${filetype}&startdate=${txtsdate}&enddate=${txtedate}&level=${level.toUpperCase()}&detail=${detail.toUpperCase()}&waste=${WasteHist}&shipto${shipTo.length?'='+shipTo:''}&displaycode=${DisplayCode}&sort${sort.length?'='+sort:''}`" target="_blank">Submit</a>

                                <div v-if="!fileUrl">
                                    
                                    <div v-if="busy" class="d-flex align-items-center justify-content-start">
                                        <div class="spinner-border" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                        Please wait
                                    </div>

                                </div>
                                <div v-else class="text-center mt-3">
                                    <a :href="fileUrl" target="_blank" class="btn btn-primary" :download="$root.getCustomerNumber()+'OrderSummary.'+filetype.toLowerCase()">Download File</a>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </PageContent>
  </template>
  <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/FlaU1LzVojc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
  <script>
  import axios from 'axios';
  import PageContent from '@/components/PageContent.vue';
  import NotReady from '@/components/NotReady.vue';
  import PageTitle from '@/components/PageTitle.vue';
  export default {
    name: 'OrderSummaryDataFile',
    components: {PageContent, PageTitle,  NotReady},
    data(){
        return {
            busy:false,
            ready:false,
            disabled:false,
            locations:[],
            LOCFILTER:'',
            WasteHist:'OFF',
            retry:1,
            txtsdate:this.$root.moment().startOf('week').format('MM/DD/YYYY'),
            txtedate:this.$root.moment().endOf('week').format('MM/DD/YYYY'),
            level:'Total',
            detail:'Price Code',
            filetype:'PDF',
            DisplayCode:'LABEL CODE',
            waste:'NO',
            sort:'',
            shipTo:localStorage.getItem('shipTo')!=null?localStorage.getItem('shipTo'):'',
            fileUrl:'',
        }
    },
    watch:{
        filetype(newVal){
            if(newVal=='PDF'){
                this.sort = '';
            }
            else this.sort = 'ITEM #';
        }
    },
    async mounted(){
        this.ready = true;
        await Sleep(10);

        $( ".datepicker" ).datepicker({
            onSelect:async (date,target)=>{
                this[target.input.attr('name')] = date;
            }
        });

        
    },
    methods:{
       async getFile(e){
        this.fileUrl = '';
        this.busy = true;
        let res = await axios.get(`${this.$store.state.api}/purchasehist?url=${btoa(e.target.href)}`);
        this.fileUrl = (res.replace(new RegExp(/"/g),''))
        this.busy = false;
       }
    },
  }
  </script>
  <style lang="scss" scoped>
    
  </style>
